import { render, staticRenderFns } from "./FeedItemCall.vue?vue&type=template&id=31719adf&scoped=true&"
import script from "./FeedItemCall.vue?vue&type=script&lang=js&"
export * from "./FeedItemCall.vue?vue&type=script&lang=js&"
import style0 from "./FeedItemCall.vue?vue&type=style&index=0&id=31719adf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31719adf",
  null
  
)

export default component.exports